<template>
  <div>
    <div v-if="owners.length === 1 && displayLabel">Stock: {{ this.firstOwnerLabel }}</div>

    <SelectInput
      v-if="owners.length > 1"
      name="stock"
      :label="$t('addShooting.stockLabel') + ' *'"
      itemValue="ownerId"
      itemText="label"
      :items="ownersWithLabel"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import SelectInput from '@/components/common/atoms/SelectInput.vue'

export default {
  name: 'SelectFieldStock',

  components: {
    SelectInput
  },

  props: {
    displayLabel: { type: Boolean, required: false, default: false },
    owners: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ownersWithLabel() {
      let ownersWithLabel = []

      if (this.owners.length === 0) return

      this.owners.forEach(o => {
        const newOwner = {
          ...o,
          label: !o.label || o.label === '' ? o.ownerId : o.label
        }

        ownersWithLabel.push(newOwner)
      })

      return ownersWithLabel
    },

    firstOwnerLabel() {
      return this.ownersWithLabel && this.ownersWithLabel.length === 1 && this.ownersWithLabel[0].label
    }
  }
}
</script>
